import { useMemo } from "react";
import { M } from "../lib/site";
import { MaskLines, FadeUp } from "./Reveal";
import { Field, useSubmit, SubmitButton } from "./FormBits";

const OPENING_DAY = new Date(2026, 10, 13);

const nextFridays = (n = 6) => {
  let d = new Date();
  d.setDate(d.getDate() + ((5 - d.getDay() + 7) % 7));
  if (d < OPENING_DAY) d = new Date(OPENING_DAY);
  return Array.from({ length: n }, (_, i) => {
    const x = new Date(d);
    x.setDate(d.getDate() + i * 7);
    const label = x.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" });
    return x.toDateString() === OPENING_DAY.toDateString() ? `${label} — Grand Opening` : label;
  });
};

export const GuestList = () => {
  const fridays = useMemo(() => nextFridays(), []);
  const { state, onSubmit } = useSubmit("/guestlist", "You're on the list request — see you Friday.");

  return (
    <section id="guestlist" className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-10 sm:py-36" data-testid="guestlist-section">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-6">03 — Guest List</p>
          <MaskLines lines={["Guest", "List."]}
            className="font-display text-6xl leading-[0.9] text-[#F8F6F0] sm:text-6xl lg:text-7xl" />
          <FadeUp delay={0.15}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[var(--stone)] sm:text-lg">
              Add your name for Friday — grand opening included.
            </p>
            <div className="mt-10 aspect-[4/5] overflow-hidden rounded-[28px] lg:max-h-[560px]">
              <img src={M.guestlist} alt="Two guests laughing with cocktails under the mirror balls" loading="lazy" className="h-full w-full object-cover object-[50%_30%]" data-testid="guestlist-photo" />
            </div>
          </FadeUp>
        </div>

        <FadeUp className="lg:col-span-7" delay={0.1}>
          <form onSubmit={onSubmit} data-testid="guestlist-form"
            className="grid gap-8 rounded-[28px] border border-[var(--line)] bg-[var(--card)]/70 p-7 backdrop-blur-xl sm:grid-cols-2 sm:p-12">
            <Field label="Full name" name="name" required testid="guestlist-name-input" placeholder="Your name" className="sm:col-span-2" />
            <Field label="Email" name="email" type="email" required testid="guestlist-email-input" placeholder="you@email.com" />
            <Field label="Mobile" name="mobile" type="tel" required testid="guestlist-mobile-input" placeholder="04xx xxx xxx" />
            <Field label="Which Friday" name="date" as="select" required testid="guestlist-date-select" defaultValue={fridays[0]}>
              {fridays.map((f) => <option key={f} value={f}>{f}</option>)}
            </Field>
            <Field label="Group size" name="group_size" as="select" required testid="guestlist-size-select" defaultValue="2">
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"].map((n) => <option key={n} value={n}>{n} {n === "1" ? "person" : "people"}</option>)}
            </Field>
            <Field label="Celebrating anything?" name="occasion" testid="guestlist-occasion-input" placeholder="Birthday, promotion, just because…" className="sm:col-span-2" />
            <div className="sm:col-span-2">
              <SubmitButton state={state} label="Join the guest list" testid="guestlist-submit-btn" />
            </div>
          </form>
        </FadeUp>
      </div>
    </section>
  );
};
